import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back-v3",
  "use": "icon-back-v3-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-back-v3\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M16 16V0H0v16z\" fill=\"none\" /><path d=\"M2.661 4.821a1 1 0 0 0 0 1.414l5.303 5.304a.5.5 0 0 0 .708 0l5.303-5.304a1 1 0 0 0-1.414-1.414L8.672 8.71a.5.5 0 0 1-.707 0l-3.89-3.889a1 1 0 0 0-1.414 0z\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol